import { Col, Form, Row } from 'react-bootstrap';
import { useSearchParams } from 'react-router-dom';

import { Formik } from 'formik';

import {
  DidGroupsExistingFilter,
  DidGroupsExistingTable,
} from '@components/Capacity/DidGroups/Existing';
import { didGroupsApi } from '@reducers/capacity';

export const Existing = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  return (
    <Formik
      enableReinitialize
      initialValues={{
        country: searchParams.get('country') || '',
        plan: searchParams.get('plan') || '',
        type: searchParams.get('type') || '',
        name: searchParams.get('name') || '',
      }}
      onSubmit={() => {}}
    >
      <Form as={Row}>
        <Col md={3}>
          <DidGroupsExistingFilter
            searchParams={searchParams}
            setSearchParams={setSearchParams}
          />
        </Col>
        <Col md={9}>
          <DidGroupsExistingTable
            useData={didGroupsApi.useGetListQuery}
            searchParams={searchParams}
            setSearchParams={setSearchParams}
          />
        </Col>
      </Form>
    </Formik>
  );
};
